// 展覽主視覺輪播
module.exports = [
  {
    href: "https://www.tpte.tw/en",
    src: "https://cdn.top-link.com.tw/uploadfiles/99/upload/images/2023_TPTE_topBN.jpg",
    alt: "2023_TPTE_topBN.jpg",
  },
  {
    href: "https://tpemombaby-fair.top-link.com.tw/",
    src: "https://cdn.top-link.com.tw/uploadfiles/99/upload/images/2023_tpemombaby_topBN.jpg",
    alt: '2023_tpemombaby_topBN.jpg',
  },
  {
    href: "https://taipeifood.top-link.com.tw/",
    src: "https://cdn.top-link.com.tw/uploadfiles/99/upload/images/2023_taipeifood_topBN.jpg",
    alt: '2023_taipeifood_topBN.jpg',
  },
  {
    href: "https://www.tte.tw/en/",
    src: "https://cdn.top-link.com.tw/uploadfiles/99/upload/images/2023_TTE_topBN.jpg",
    alt: '2023_TTE_topBN.jpg',
  },
  {
    href: "https://beautyshow.top-link.com.tw",
    src: "https://cdn.top-link.com.tw/uploadfiles/99/upload/images/2023_beautyshow_topBN.jpg",
    alt: '2023_beautyshow_topBN.jpg',
  },
  {
    href: "https://www.tite.com.tw/en/",
    src: "https://cdn.top-link.com.tw/uploadfiles/99/upload/images/2023_TITE_topBN.jpg",
    alt: '2023_TITE_topBN.jpg',
  },
  // {
  //   href: "",
  //   src: "",
  //   alt: '',
  // },
]



// WEBPACK FOOTER //
// ./src/plugins/banner.js